import { render, staticRenderFns } from "./ImgForm.vue?vue&type=template&id=2b7f9b22&"
import script from "./ImgForm.vue?vue&type=script&lang=js&"
export * from "./ImgForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports